import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { userActions } from '../../_actions';
import { userService } from '../../_services';

class ForgetPasswordPage extends React.Component
{
    constructor(props){
        super(props); 

        this.state = {
            email : '' , 
            disableSubmit : false 
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event){
        this.setState ({
            [event.target.name] : event.target.value  //update state of corresponding input name 
        })
    }

    handleSubmit(event){
        event.preventDefault();

        const { dispatch } = this.props;

        this.setState({
            disableSubmit : true
        });

        userService.forgetPassword(this.state);
    }

    render(){
        let {email} = this.state; 
        const {loading} = this.props;

        const disableSubmit = this.state.disableSubmit ? 'disabled' : '' ; 

        return (
            <div>
                <div className="columns">
                    <div className="column is-6">
                        <h3 className="title">Forget Password</h3>
                    </div>
                </div>
                
                <form onSubmit={this.handleSubmit}>
                    <div className="field">
                        <div className="control m-t-lg">
                            <div className="level is-mobile">
                                <div className="level-left control-label">Email Address  </div>
                            </div>
                            <input className="input" type="email" name="email" value={email} onChange={this.handleChange} placeholder="" />
                        </div>
                        <div className="control m-t-lg">
                            <input type="submit" disabled={disableSubmit} className="button button-submit"/>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { loading } = state;
    return {
        loading 
    };
}

const connectedLoginPage = connect(mapStateToProps)(ForgetPasswordPage);
export { connectedLoginPage as ForgetPasswordPage }; 



// WEBPACK FOOTER //
// ./src/Views/ForgetPasswordPage/ForgetPasswordPage.jsx